import { render } from "./CustomSumField.vue?vue&type=template&id=849bc092&scoped=true"
import script from "./CustomSumField.vue?vue&type=script&lang=js"
export * from "./CustomSumField.vue?vue&type=script&lang=js"

import "./CustomSumField.vue?vue&type=style&index=0&id=849bc092&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-849bc092"]])

export default __exports__